
  import { defineComponent, inject } from "vue";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";

  export default defineComponent({
    name: "SimpleInputV2",

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    extends: BaseProcessComponentV2,

    data() {
      return {
        defaultValue: "" as any,
        loading: false as boolean,
        prefix: null as string | null,
      };
    },
  });
